// extracted by mini-css-extract-plugin
export var animationFadeUp = "style-module--animationFadeUp--596d9";
export var background = "style-module--background--a9ed5";
export var content = "style-module--content--e24a4";